import React from 'react';
import { randomUUID } from '../../../../../utils/cms';

const Image = React.forwardRef((props, ref) => {
    // this should be in every component, its used to forward the click event to the builder if in preview mode
    let preview_click=null;
    if (props.is_preview && props.onClick){
        preview_click = props.onClick;
    }

    // Show a better placeholder in preview mode when no src is set
    const hasNoSource = !props?.src;
    const placeholderSrc = hasNoSource && props.is_preview
        ? "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='250' height='250'%3E%3Crect width='250' height='250' fill='%23f0f0f0'/%3E%3Ctext x='50%25' y='45%25' dominant-baseline='middle' text-anchor='middle' font-family='Arial, sans-serif' font-size='48' fill='%23ccc'%3E%F0%9F%96%BC%3C/text%3E%3Ctext x='50%25' y='60%25' dominant-baseline='middle' text-anchor='middle' font-family='Arial, sans-serif' font-size='14' fill='%23999'%3EClick to add image%3C/text%3E%3C/svg%3E"
        : props?.src || "https://via.placeholder.com/250";

    let Component = "img";
    let _props={
        id: props.is_preview ? `preview-${randomUUID()}` : props.id,
        className: `Image_${props.page_id} ${props.className || ""}`.trim().replace(/\s+/g,' '),
        style: {
            display:"block",
            minWidth: hasNoSource && props.is_preview ? "100px" : undefined,
            minHeight: hasNoSource && props.is_preview ? "100px" : undefined,
            cursor: hasNoSource && props.is_preview ? "pointer" : undefined,
            ...(props?.style || {})
        },
        src: placeholderSrc,
        alt: props?.alt || "",
        loading: props?.loading || "lazy",
        decoding: props?.decoding || "async",
    }
    if (props?.width) _props.width=props.width;
    if (props?.height) _props.height=props.height;
    if (props?.image_align) {
        switch(props.image_align){
            case "left":
                _props.style = {..._props.style, marginRight:"auto"};
                break;
            case "right":
                _props.style = {..._props.style, marginLeft:"auto"};
                break;
            case "center":
                _props.style = {..._props.style, marginLeft:"auto", marginRight:"auto"};
                break;
            default:
                break;
        }
    }

    if (props.url) {
        return (
            <a ref={ref} href={!props.is_preview && props.url? props.url : "#!"} target={props.target || "_self"}  onClick={preview_click}
                    style={{...props.style, margin:0,padding:0,border:0,background:"transparent",boxShadow:"none"}}>
                <Component {..._props}/>
            </a>
        );
    } else return <Component ref={ref} onClick={preview_click} {..._props} />;

});

export default Image;